import { useGet } from "./hooks";
//import conference from "./../assets/conference.jpg";
function ConferenceItems() {
  const eventURL =
    "https://stetor16.dreamhosters.com/wp-json/acf/v3/conferences";
  const [data, loading] = useGet(eventURL);

  return (
    <>
      <div className="conferences__data-container  ">
        <h1 className="site__heading pb-3">Conferences</h1>
        {loading ? (
          "Loading..."
        ) : (
          <div className="conferences__events-box">
            {data.map((d, index) => {
              return (
                <div
                  key={index}
                  className="conferences__event-description  pb-2"
                >
                  <p className="site__paragraph">{d.acf.event_desc}</p>
                  {d.acf.event_link && (
                    <a
                      target="_blank"
                      href={d.acf.event_link.url}
                      className="btn btn--white btn--animated m-3"
                    >
                      {d.acf.event_link.title}
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
export default ConferenceItems;
